import { Icon } from "ant-design-vue";
import Vue from "vue";
import VueRouter from "vue-router";
import { svgList } from "./svg";
Vue.use(VueRouter);

let routes = [
  {
    // will match everything
    path: "*",
    component: () => import("../views/404.vue"),
  },
  {
    path: "/",
    name: "Dashboard",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    layout: "dashboard",
    isMenu: true,
    title: "主页",
    svg: svgList.dashboard,
    component: () => import("../views/Dashboard.vue"),
  },
  {
    name: "Prepare",
    path: "/prepare",
    isMenu: false,
    component: () => import("../views/prepare/prepare.vue"),
    meta: {
      title: "支付中心",
    },
  },
  {
    path: "/topUp",
    name: "TopUp",
    layout: "dashboard",
    isMenu: true,
    svg: svgList.lm,
    title: "商家联盟",
    component: () => import("@/views/topUp/index.vue"),
  },
  // {
  //   path: "/consumption",
  //   name: "Consumption",
  //   layout: "dashboard",
  //   isMenu: true,
  //   svg: svgList.consumption,
  //   title: "扣费记录",
  //   icon: "",

  //   component: () => import("../views/consumption.vue"),
  // },
  {
    path: "/reportManagement",
    name: "ReportManagement",
    layout: "dashboard",
    isMenu: true,
    svg: svgList.reportManagement,
    title: "报告管理",
    component: () => import("../views/reportManagement.vue"),
  },
  {
    path: "/report-help",
    name: "ReportHelp",
    layout: "dashboard",
    isMenu: true,
    svg: svgList.help,
    title: "报表说明",
    component: () => import("@/views/report-help/index.vue"),
  },

  {
    path: "/login",
    name: "Sign-In",
    component: () => import("../views/Sign-In.vue"),
  },
  {
    path: "/sign-up",
    name: "Sign-Up",
    meta: {
      layoutClass: "layout-sign-up",
    },
    component: () => import("../views/Sign-Up.vue"),
  },

  {
    path: "/setting",
    name: "Setting",
    layout: "dashboard",
    isMenu: true,
    title: "设置",
    svg: svgList.setting,
    component: () => import("../views/setting/setting.vue"),
  },
];

// Adding layout property from each route to the meta
// object so it can be accessed later.
function addLayoutToRoute(route, parentLayout = "default") {
  route.meta = route.meta || {};
  route.meta.layout = route.layout || parentLayout;
  route.meta.title = route.title || "";
  if (route.children) {
    route.children = route.children.map((childRoute) =>
      addLayoutToRoute(childRoute, route.meta.layout)
    );
  }
  return route;
}

routes = routes.map((route) => addLayoutToRoute(route));

const createRouter = () => new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    }
    return {
      x: 0,
      y: 0,
      behavior: "smooth",
    };
  },
});
const router = createRouter()


export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router;
